// extracted by mini-css-extract-plugin
export default {"container":"PersonPhoto_container__qtthz","photo":"PersonPhoto_photo__2VtTd","favorite":"PersonPhoto_favorite__BvgCx"};